<template>
  <table>
    <thead>
      <tr>
        <th rowspan="2">評分順序</th>
        <th rowspan="2">分級指標</th>
        <th rowspan="2">分級參數</th>
        <th rowspan="2">合格品</th>
        <th rowspan="2">非合格品</th>
        <th rowspan="2">影像判別方式</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>1</td>
        <td>葉片數</td>
        <td>{{ maxLeafLength }}</td>
        <td>{{ minLeafCount }}</td>
        <td>未達標</td>
        <td>側視圖</td>
      </tr>
      <tr>
        <td>2</td>
        <td>植株大小</td>
        <td>株幅長</td>
        <td>{{ longSide }}</td>
        <td>未達標</td>
        <td>俯視圖</td>
      </tr>
      <tr>
        <td>3</td>
        <td>葉序角度</td>
        <td>株幅長 / 株幅寬</td>
        <td>{{ aspectRatio }}</td>
        <td>未達標</td>
        <td>俯視圖</td>
      </tr>
      <tr>
        <td>4</td>
        <td>最大葉片長寬比</td>
        <td>
          先測量最長葉片 <br />
          再量測其寬
        </td>
        <td>{{ largestLeafRatio }}</td>
        <td>未達標</td>
        <td>俯視圖 + 側視圖</td>
      </tr>
      <tr>
        <td colspan="6" class="text-left">
          非合格品：指評分順序 4 項指標任何 1 項指標未達標就符合
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  name: "BaseTable",
  props: {
    maxLeafLength: {
      type: String,
      default: "",
    },
    minLeafCount: {
      type: String,
      default: "",
    },
    largestLeafRatio: {
      type: String,
      default: "",
    },
    longSide: {
      type: String,
      default: "",
    },
    aspectRatio: {
      type: String,
      default: "",
    },
  },
};
</script>

<style lang="scss" scoped>
table {
  width: 100%;
  min-width: 1000px;

  col {
    width: 9%;
  }

  tr {
    &:hover {
      background: #e0ece420;
    }
  }

  th {
    text-align: center;
    color: #393b44;
    background-color: #e0ece4;
    font-weight: normal;
    padding: 0.5em 0.5rem;
  }

  td {
    color: #393b44;
    border: 1px solid #e0ece4;
    font-weight: light;
    padding: 1em 0.5rem;
    text-align: center;
  }
}
</style>
